export enum MuteType {
  NO = 0,
  YES = 1,
  HIDDEN = 2,
}
